import { CpMovementRequestInterface } from '../../../interfaces/request/movement/cp-movement-request-interface';

export class CpMovementRequestModel implements CpMovementRequestInterface {
  Cards: string = '';
  ClaimType: string = '';
  EndDate: string = '';
  Page: number = 1;
  PageSize: number = 5;
  StartDate: string = '';

  constructor(init?: Partial<CpMovementRequestModel>) {
    Object.assign(this, init);
  }
}
